import React from "react";

//PODS
//--ADMIN
import HVSAdminLoginControl from "./administration/HVSLoginForm/loginControl";
import Printing3DAdmin from "./3dPrintingShop/admin/podRouter";

//--FRONTEND
import MembershipExtraLogin from "./membershipExtra/loginPod/loginForm";
import Printing3DFrontEnd from "./3dPrintingShop/frontEnd/podRouter";

function EnvironmentPodsMap(props) {
    return (
        <div>
            {props.podCode == "loginForm" && <HVSAdminLoginControl />}
            {props.podCode == "CPOD_MEMBEREXTRA_FREND" && <MembershipExtraLogin />}
            {props.podCode == "CPOD_3DPRINTINGSHOP_ADMIN" && <Printing3DAdmin />}
            {props.podCode == "CPOD_3DPRINTINGSHOP_FREND" && <Printing3DFrontEnd />}
        </div>
    );
}

export function EnvironmentPodsMap_PageViewer(props) {
    return null;
}

export function SegmentedMenus(code) {
    return null;
}

export default EnvironmentPodsMap;
